// Catalogues FANUC, tailles fallback, libellés i18n calendrier.

// Hardcoded fallback — used if window.ProbotSoum.robotCatalog is missing.
// La source de vérité est le catalogue éditable via l'admin
// (onglet « Robots » → option probot_soum_robot_catalog).
// v1.1.6 — Heures recalibrées sur expérience terrain Probot :
//   palletisation 6h, grande_taille 6h, moyen 5h, petit 4h, collab 2h, scara 3h
const FALLBACK_MODELS = [
	{ id: 'm10',     name: 'M-10iA / M-10iD',      category: 'Material Handling',     axes: 6, hours: 5 },
	{ id: 'm20',     name: 'M-20iA / M-20iD',      category: 'Material Handling',     axes: 6, hours: 5 },
	{ id: 'm710',    name: 'M-710iC / M-710iD',    category: 'Material Handling',     axes: 6, hours: 5 },
	{ id: 'r2000b',  name: 'R-2000iB',             category: 'Palletizing',           axes: 6, hours: 6 },
	{ id: 'r2000c',  name: 'R-2000iC',             category: 'Palletizing',           axes: 6, hours: 6 },
	{ id: 'm410b',   name: 'M-410iB',              category: 'Palletizing',           axes: 4, hours: 6 },
	{ id: 'm410c',   name: 'M-410iC',              category: 'Palletizing',           axes: 4, hours: 6 },
	{ id: 'm900',    name: 'M-900iA / M-900iB',    category: 'Heavy Payload',         axes: 6, hours: 8 },
	{ id: 'crx10',   name: 'CRX-10iA',             category: 'Collaborative (CRX)',   axes: 6, hours: 2 },
	{ id: 'crx10l',  name: 'CRX-10iA/L',           category: 'Collaborative (CRX)',   axes: 6, hours: 2 },
	{ id: 'crx20',   name: 'CRX-20iA/L',           category: 'Collaborative (CRX)',   axes: 6, hours: 2 },
	{ id: 'crx25',   name: 'CRX-25iA',             category: 'Collaborative (CRX)',   axes: 6, hours: 2 },
	{ id: 'crx30',   name: 'CRX-30iA',             category: 'Collaborative (CRX)',   axes: 6, hours: 2 },
	{ id: 'arc100',  name: 'ARC Mate 100iD',       category: 'Arc Welding',           axes: 6, hours: 6 },
	{ id: 'arc120',  name: 'ARC Mate 120iD',       category: 'Arc Welding',           axes: 6, hours: 6 },
	{ id: 'lr200',   name: 'LR Mate 200iD',        category: 'Small / Compact',       axes: 6, hours: 4 },
	{ id: 'lr200l',  name: 'LR Mate 200iD/7L',     category: 'Small / Compact',       axes: 6, hours: 4 },
	{ id: 'sr3',     name: 'SR-3iA (SCARA)',       category: 'Small / Compact',       axes: 4, hours: 3 },
	{ id: 'p250',    name: 'P-250iB',              category: 'Painting',              axes: 6, hours: 6 },
	{ id: 'paint70', name: 'Paint Mate 70iA',      category: 'Painting',              axes: 6, hours: 6 },
	{ id: 'autre',   name: 'Autre modèle FANUC',   category: 'Autre / Other',         axes: 6, hours: 6 },
];

function buildCatalog() {
	var raw = ( typeof window !== 'undefined' && window.ProbotSoum && Array.isArray( window.ProbotSoum.robotCatalog ) )
		? window.ProbotSoum.robotCatalog
		: FALLBACK_MODELS;
	return raw.map( function ( r ) {
		return {
			id:        r.id,
			name:      r.name,
			cat:       r.category || r.cat || '',
			axes:      typeof r.axes  === 'number' ? r.axes  : parseInt( r.axes,  10 ) || 6,
			hours:     typeof r.hours === 'number' ? r.hours : parseFloat( r.hours ) || 8,
			materials: Array.isArray( r.materials ) ? r.materials : [],
		};
	} );
}

export const FANUC_MODELS = buildCatalog();

export const QUICK_PICKS = {
	unknown:   { id: 'unknown',   name: "Je ne connais pas le modèle / I don't know the model", cat: 'Autre / Other', axes: 0 },
	noinfonow: { id: 'noinfonow', name: "Info non disponible / I don't have the info right now", cat: 'Autre / Other', axes: 0 },
	other:     { id: 'other',     name: 'Autre — à préciser / Other — to specify',               cat: 'Autre / Other', axes: 0 },
};

const PSU_BASE = ( typeof window !== 'undefined' && window.ProbotSoum && window.ProbotSoum.pluginUrl )
	? window.ProbotSoum.pluginUrl
	: '/wp-content/plugins/probot-soumission/';

export const SIZE_IMGS = {
	small:  PSU_BASE + 'assets/img/sizes/small.jpg',
	medium: PSU_BASE + 'assets/img/sizes/medium.jpg',
	large:  PSU_BASE + 'assets/img/sizes/large.jpg',
	xlarge: PSU_BASE + 'assets/img/sizes/xlarge.jpg',
};

export const SIZE_KEYS       = [ 'small', 'medium', 'large', 'xlarge' ];
export const SIZE_LABELS_FR  = [ 'Petit', 'Moyen', 'Grand', 'Très grand' ];
export const SIZE_LABELS_EN  = [ 'Small', 'Medium', 'Large', 'Extra large' ];
export const SIZE_DETAILS_FR = [ 'LR Mate · ~5 kg · ½ j', 'ARC Mate, M-10 · ~10 kg · 1 j', 'R-2000, M-410 · ~20 kg · 1 j', 'M-900, M-2000 · ~35 kg · 1.5 j' ];
export const SIZE_DETAILS_EN = [ 'LR Mate · ~5 kg · ½ day', 'ARC Mate, M-10 · ~10 kg · 1 day', 'R-2000, M-410 · ~20 kg · 1 day', 'M-900, M-2000 · ~35 kg · 1.5 days' ];

export const MONTH_NAMES = {
	fr: [ 'janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre' ],
	en: [ 'January','February','March','April','May','June','July','August','September','October','November','December' ],
};

export const DOW_SHORT = {
	fr: [ 'L','M','M','J','V','S','D' ],
	en: [ 'M','T','W','T','F','S','S' ],
};
